import { Injectable } from '@angular/core';
import { NavigationItemInterface } from '../interfaces/navigation.interface';

export enum SweetPermissions {
  BENCHMARKS = 'view-benchmarks',
}

@Injectable()
export class NavigationPermissionsHelper {

  public getNavigationItems(): NavigationItemInterface[] {
    return [
      {
        key: 'ecommerce',
        url: '/ecommerce',
        label: 'navigation.ecommerceBenchmarks',
        shouldDisplay: true,
      },
      {
        key: 'google-analytics',
        url: '/google-analytics',
        label: 'navigation.gaBenchmarks',
        shouldDisplay: true,
      },
    ];
  }
}
